var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarketingBannersIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.309,
    height: 36.033,
    viewBox: "0 0 39.309 36.033",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(0 14.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M28.585,33.121a3.267,3.267,0,0,1-.835-.108L2.424,26.23A3.306,3.306,0,0,1,.108,22.218L3.3,10.307a.819.819,0,0,1,1.582.423L1.692,22.637A1.662,1.662,0,0,0,2.854,24.65l25.316,6.779a1.63,1.63,0,0,0,1.993-1.153l1.279-4.74a.819.819,0,1,1,1.582.426L31.748,30.7a3.271,3.271,0,0,1-3.163,2.426Z",
    transform: "translate(0 -9.701)",
    fill: "#009dd7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(6.551 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M33.482,28.206H7.276A3.279,3.279,0,0,1,4,24.93V5.276A3.279,3.279,0,0,1,7.276,2H33.482a3.279,3.279,0,0,1,3.276,3.276V24.93A3.279,3.279,0,0,1,33.482,28.206ZM7.276,3.638A1.641,1.641,0,0,0,5.638,5.276V24.93a1.641,1.641,0,0,0,1.638,1.638H33.482a1.641,1.641,0,0,0,1.638-1.638V5.276a1.641,1.641,0,0,0-1.638-1.638Z",
    transform: "translate(-4 -2)",
    fill: "#009dd7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(11.465 6.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M10.276,11.551a3.276,3.276,0,1,1,3.276-3.276A3.279,3.279,0,0,1,10.276,11.551Zm0-4.914a1.638,1.638,0,1,0,1.638,1.638A1.641,1.641,0,0,0,10.276,6.638Z",
    transform: "translate(-7 -5)",
    fill: "#009dd7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(6.665 11.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M4.889,22.913a.818.818,0,0,1-.58-1.4l7.736-7.736a2.517,2.517,0,0,1,3.474,0l2.3,2.3L24.2,8.434a2.461,2.461,0,0,1,1.87-.884h.018a2.455,2.455,0,0,1,1.866.857L36.516,18.4a.819.819,0,1,1-1.243,1.066L26.707,9.473a.81.81,0,0,0-.622-.285.869.869,0,0,0-.629.295l-6.949,8.338a.816.816,0,0,1-.593.293.788.788,0,0,1-.616-.239l-2.937-2.937a.841.841,0,0,0-1.158,0L5.467,22.674a.816.816,0,0,1-.578.239Z",
    transform: "translate(-4.07 -7.55)",
    fill: "#009dd7"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketingBannersIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marketing-banners-icon.8615f72f.svg";
export { ForwardRef as ReactComponent };